import { render, staticRenderFns } from "./requestsUsers.vue?vue&type=template&id=8c01bae6&"
import script from "./requestsUsers.vue?vue&type=script&lang=js&"
export * from "./requestsUsers.vue?vue&type=script&lang=js&"
import style0 from "./requestsUsers.vue?vue&type=style&index=0&id=8c01bae6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports